
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "8px",
    "height": "8px",
    "viewBox": "0 0 8 8",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "箭头_右下"
        }
      ]
    },
    {
      "tag": "desc",
      "children": [
        {
          "text": "Created with Sketch."
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "页面-1",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "二级标签页",
            "transform": "translate(-360.000000, -219.000000)",
            "fill": "#1677FF",
            "fill-rule": "nonzero"
          },
          "children": [
            {
              "tag": "g",
              "attrsMap": {
                "id": "箭头_右下",
                "transform": "translate(360.000000, 219.000000)"
              },
              "children": [
                {
                  "tag": "polygon",
                  "attrsMap": {
                    "id": "路径",
                    "points": "6.17678285 0.739197183 8 0.739197183 8 8 0.707135687 8 0.707135687 6.18479823 4.90054388 6.18479823 -9.09494702e-13 1.27064102 1.27625179 0 6.17679567 4.91415721"
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  